"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _SearchIcon = require("./SearchIcon");
Object.keys(_SearchIcon).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _SearchIcon[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _SearchIcon[key];
    }
  });
});
